import { Link } from "react-router-dom";
import { Mail, Phone } from "lucide-react";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { href: "/o-mnie", label: "O mnie" },
    { href: "/o-firmie", label: "O firmie" },
    { href: "/blog", label: "Blog" },
    { href: "/kontakt", label: "Kontakt" },
  ];

  const serviceLinks = [
    { href: "/umow-spotkanie", label: "Optymalizacja umów" },
    { href: "/umow-spotkanie", label: "Planowanie emerytalne" },
    { href: "/umow-spotkanie", label: "Zarządzanie majątkiem" },
    { href: "/umow-spotkanie", label: "Edukacja finansowa" },
  ];

  return (
    <footer data-testid="footer" className="bg-[#0A192F] text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="space-y-6">
            <Link to="/" className="flex items-center">
              <div>
                <span className="font-display text-xl font-semibold block leading-tight">
                  Jan Domański
                </span>
                <span className="text-xs text-slate-400">
                  Planer finansowy
                </span>
              </div>
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed">
              Profesjonalne doradztwo finansowe dla osób, które cenią 
              długoterminowe bezpieczeństwo i&nbsp;świadome budowanie majątku.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-display text-lg font-semibold mb-6">Nawigacja</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    data-testid={`footer-link-${link.href.replace("/", "")}`}
                    className="text-slate-400 hover:text-[#D4AF37] transition-colors text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-display text-lg font-semibold mb-6">Usługi</h4>
            <ul className="space-y-3">
              {serviceLinks.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.href}
                    className="text-slate-400 hover:text-[#D4AF37] transition-colors text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-display text-lg font-semibold mb-6">Kontakt</h4>
            <ul className="space-y-4">
              <li className="flex items-center gap-3">
                <Phone size={18} className="text-[#D4AF37] flex-shrink-0" />
                <a
                  href="tel:+48518607320"
                  className="text-slate-400 hover:text-[#D4AF37] transition-colors text-sm"
                >
                  518 607 320
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={18} className="text-[#D4AF37] flex-shrink-0" />
                <a
                  href="mailto:jan.domanski@inpartners.pl"
                  className="text-slate-400 hover:text-[#D4AF37] transition-colors text-sm"
                >
                  jan.domanski@inpartners.pl
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6">
          <div className="flex justify-center">
            <p className="text-slate-500 text-xs">
              © {currentYear} Jan Domański. Wszelkie prawa zastrzeżone.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
